import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Tooltip } from "@components/common";
import utils from "@utils";

const NonRKPayInvoiceDetailBalanceDisplay = ({
  nonRKPayInvoiceDetailHook: {
    invoiceState,
    nonrkpayDetailPrepayEnhancementsEnabled,
  },
}) => {
  const { lang } = global;

  const {
    voided,
    isEstimate,
    totals: { balance, appliedPayments },
    estimateFinalized,
  } = invoiceState;

  const isRefundDue = voided && isEstimate && appliedPayments > 0;
  const isPrepayEstimate =
    nonrkpayDetailPrepayEnhancementsEnabled &&
    isEstimate &&
    estimateFinalized &&
    balance !== 0;

  const { title, amount, amountClass, showTooltip } = useMemo(() => {
    if (isRefundDue) {
      return {
        title: lang.t("Refund Due"),
        amount: appliedPayments,
        amountClass: "",
        showTooltip: false,
      };
    }
    if (isPrepayEstimate) {
      const overpaid = balance < 0;
      return {
        title: overpaid
          ? lang.t("Overpaid Estimate Balance")
          : lang.t("Unpaid Estimate Balance"),
        amount: balance,
        amountClass: "text-muted",
        showTooltip: overpaid,
      };
    }
    return {
      title: lang.t("Balance Due"),
      amount: balance,
      amountClass: "",
      showTooltip: false,
    };
  }, [isRefundDue, isPrepayEstimate, appliedPayments, balance]);

  return (
    <div className="row">
      <div className="col-xs-9">
        {showTooltip && (
          <Tooltip
            content={lang.t(
              "This estimate was overpaid; a refund can be processed if there are available funds after associated invoice(s) are paid"
            )}
          >
            <i className="hidden-xs rkf rkf-question-solid tooltip-icon" />
          </Tooltip>
        )}
        {" "}
        <strong className={amountClass}>{title}</strong>
      </div>
      <div className="col-xs-3">
        <span className={amountClass}>
          {utils.currencyFormatter(amount)}
        </span>
      </div>
    </div>
  );
};

NonRKPayInvoiceDetailBalanceDisplay.propTypes = {
  nonRKPayInvoiceDetailHook: PropTypes.object.isRequired,
};

export default NonRKPayInvoiceDetailBalanceDisplay;
